import type { Dispatch, RefObject } from "react";
import type { LocationFilterAction } from "../filter-reducer";
import { GeometryFilterModal } from "../geometry-filter/modal";
import type { LocalLocationFilterWithId, LocationFilterType } from "../types";
import { useDispatchFilter } from "./use-dispatch-filter";

interface FilterModalsProps {
  filterModalAnchorEl?: RefObject<HTMLElement | null>;
  editFilter?: LocalLocationFilterWithId | undefined;
  openFilter: LocationFilterType | false;
  dispatchFilters: Dispatch<LocationFilterAction>;
  handleFilterModalClose: () => void;
}

export const LocationFilterModals = ({
  filterModalAnchorEl,
  openFilter,
  editFilter,
  dispatchFilters,
  handleFilterModalClose,
}: FilterModalsProps) => {
  const props = {
    initialValue: editFilter,
    onClose: handleFilterModalClose,
    anchorEl: filterModalAnchorEl,
    dispatchFilters: dispatchFilters,
  };
  const { addModifyFilter, deleteFilter } = useDispatchFilter({
    dispatchFilters,
    id: editFilter?.id,
    onClose: handleFilterModalClose,
  });

  return (
    <>
      <GeometryFilterModal
        {...props}
        initialValue={editFilter?.geometry}
        open={openFilter === "geometry"}
        addModifyFilter={(filter) => {
          addModifyFilter({ geometry: filter });
        }}
        filterTitle="Polygon"
        deleteFilter={deleteFilter}
      />
    </>
  );
};
